import React, { Component } from "react";
import Header from "./components/Header";
import "./App.css";
import AboutMe from "./components/AboutMe";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Projects from "./components/Projects";
import Footer from "./components/Footer";

class App extends Component {
  render() {
    return (
      <div>
        <Header />
        <div className="mycontainer" data-bs-spy="scroll" data-bs-target="#mynav" data-bs-offset="0" tabindex="0">
          <AboutMe id='about' />
          <Skills id="skills"/>
          <Education/>
          <Projects/>
        </div>
        <Footer/>
      </div>
    );
  }
}
export default App;
